module.exports = __webpack_public_path__ + "static/media/hospitalGrid-03.23078ee6.jpg";